import { render, staticRenderFns } from "./advertisement.vue?vue&type=template&id=10a14a83&scoped=true&"
import script from "./advertisement.vue?vue&type=script&lang=js&"
export * from "./advertisement.vue?vue&type=script&lang=js&"
import style0 from "./advertisement.vue?vue&type=style&index=0&id=10a14a83&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "10a14a83",
  null
  
)

export default component.exports